// @flow

import * as React from "react"
import Modal from "react-modal"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"
import {Link} from "react-router-dom"
import {isNil} from "lodash"

import SendOfferModal from "../../components/modals/send-offer"
import DisableWebshopSourceModal from "../../components/modals/disable-webshop-source"
import Config from "../../config"
import {toDinero} from "../../util"
import {
  getProductsForLater,
  getAllProducts,
  getProductCategories,
} from "../../reducers/products"
import {getTasksByTypes} from "../../reducers/tasks"
import {
  getProductByBabyListItem,
  getBabyListTotalNew,
  getBabyListItemsByCategory,
  hasRemarks,
  hasInvoiceableWebshopSource,
} from "../../reducers/baby"
import {
  disableWebshopSource,
  removeBabyListItem,
  updateBabyListItem,
} from "../../actions/baby"

import IntakeBabyListItem from "../../components/intake/baby-list-item"
import TaskList from "../../components/task-list"

import type {
  State as ReduxState,
  BabyList,
  BabyListItem,
  BabyListOffer,
  BabyListOptionalItem,
  ProductOrSet,
  ProductCategory,
  ProductsByCategory,
  Task,
  Baby,
  Dispatch,
} from "../../types"

type Props = {
  +t: any,
  +match: any,
  +categories: $ReadOnlyArray<ProductCategory>,
  +productsByCategory: $ReadOnlyArray<ProductsByCategory>,
  +allProducts: $ReadOnlyArray<ProductOrSet>,
  +optionals: $ReadOnlyArray<BabyListOptionalItem>,
  +offers: $ReadOnlyArray<BabyListOffer>,
  +laters: $ReadOnlyArray<ProductOrSet>,
  +babyList: BabyList,
  +baby: Baby,
  +offerSending: boolean,
  +clientTasks: $ReadOnlyArray<Task>,
  +generalTasks: $ReadOnlyArray<Task>,
  +madamTasks: $ReadOnlyArray<Task>,
  +dispatch: Dispatch,
}

type State = {
  +showRemarks: boolean,
  +isModalOpen: boolean,
  +isDisableWebshopSourceModalOpen: boolean,
  +disabledWebshopSourceChecked: boolean,
  +showMadamTasks: boolean,
}

export class IntakeBabyListView extends React.Component<Props, State> {
  handleRemoveBabyListItem: (number) => void
  handleUpdateBabyListItem: (BabyListItem) => void
  handleToggleRemarks: (SyntheticMouseEvent<HTMLLinkElement>) => void
  handleToggleMadamTasks: (SyntheticMouseEvent<HTMLLinkElement>) => void
  handleSendOffer: (SyntheticMouseEvent<HTMLLinkElement>) => void

  handleCloseModal: () => void
  handleAfterOpen: () => void

  renderCategory: (any) => any
  renderItem: (any) => any

  state = {
    showRemarks: false,
    showMadamTasks: false,
    isModalOpen: false,
    isDisableWebshopSourceModalOpen: false,
    disabledWebshopSourceChecked: false,
  }

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.handleRemoveBabyListItem = this.handleRemoveBabyListItem.bind(this)
    this.handleUpdateBabyListItem = this.handleUpdateBabyListItem.bind(this)
    this.handleToggleRemarks = this.handleToggleRemarks.bind(this)
    this.handleToggleMadamTasks = this.handleToggleMadamTasks.bind(this)
    this.handleSendOffer = this.handleSendOffer.bind(this)
    this.handleDisableWebshopSource = this.handleDisableWebshopSource.bind(this)

    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleAfterOpen = this.handleAfterOpen.bind(this)

    this.renderCategory = this.renderCategory.bind(this)
    this.renderItem = this.renderItem.bind(this)
  }

  static getDerivedStateFromProps({baby, babyList}, state) {
    if (
      baby.states.includes("signed") &&
      hasInvoiceableWebshopSource(babyList, "intake_not_invoiced") &&
      hasInvoiceableWebshopSource(babyList, "bundling") &&
      !state.disabledWebshopSourceChecked
    ) {
      return {
        isDisableWebshopSourceModalOpen: true,
        disabledWebshopSourceChecked: true,
      }
    }

    return null
  }

  handleDisableWebshopSource() {
    const {
      dispatch,
      match: {
        params: {babyToken},
      },
    } = this.props

    if (!window.confirm("Zeker?")) return
    dispatch(disableWebshopSource(babyToken))
  }

  handleRemoveBabyListItem(babyItemId: number) {
    const {
      dispatch,
      match: {
        params: {babyToken},
      },
    } = this.props
    dispatch(removeBabyListItem(babyToken, babyItemId))
  }

  handleUpdateBabyListItem(babyListItem: BabyListItem) {
    const {
      dispatch,
      match: {
        params: {babyToken},
      },
    } = this.props
    dispatch(updateBabyListItem(babyToken, babyListItem))
  }

  handleToggleRemarks(e: SyntheticMouseEvent<HTMLLinkElement>) {
    e.preventDefault()
    this.setState({
      showRemarks: !this.state.showRemarks,
    })
  }

  handleToggleMadamTasks(e: SyntheticMouseEvent<HTMLLinkElement>) {
    e.preventDefault()
    this.setState({
      showMadamTasks: !this.state.showMadamTasks,
    })
  }

  handleAfterOpen() {}

  handleCloseModal() {
    this.setState({isModalOpen: false, isDisableWebshopSourceModalOpen: false})
  }

  renderModal() {
    const {isModalOpen} = this.state
    const {offers} = this.props
    if (!isModalOpen) return null
    const {
      match: {
        params: {babyToken},
      },
    } = this.props
    return (
      <SendOfferModal
        handleCloseModal={this.handleCloseModal}
        handleAfterOpen={this.handleAfterOpen}
        isFirstOffer={!(offers && offers.length)}
        babyToken={babyToken}
      />
    )
  }

  renderDisableWebshopSourceModal() {
    const {isDisableWebshopSourceModalOpen} = this.state
    if (!isDisableWebshopSourceModalOpen) return null
    const {
      match: {
        params: {babyToken},
      },
    } = this.props
    return (
      <DisableWebshopSourceModal
        handleCloseModal={this.handleCloseModal}
        handleAfterOpen={this.handleAfterOpen}
        babyToken={babyToken}
      />
    )
  }

  handleSendOffer(e: SyntheticMouseEvent<HTMLLinkElement>) {
    e.preventDefault()
    this.setState({isModalOpen: true})
  }

  renderItem(babyListItem: BabyListItem) {
    const {
      allProducts,
      match: {
        params: {babyToken},
      },
    } = this.props
    const {showRemarks} = this.state
    const product = getProductByBabyListItem(babyListItem, allProducts)
    if (!product) {
      return null
    }
    if (
      showRemarks &&
      (babyListItem.remarks == "" || isNil(babyListItem.remarks))
    ) {
      return null
    }
    const {item} = product
    switch (product.type) {
      case "product":
      case "productSet":
      case "productInSet":
        return (
          <li className="table-list-row" key={babyListItem.id}>
            <IntakeBabyListItem
              onRemove={this.handleRemoveBabyListItem}
              onUpdate={this.handleUpdateBabyListItem}
              showSettings={showRemarks}
              babyToken={babyToken}
              product={item}
              item={babyListItem}
            />
          </li>
        )
    }
  }

  renderCategory({
    category,
    items,
  }: {
    category: ProductCategory,
    items: BabyListItem[],
  }) {
    const categorySum = items
      .map((item) => item.total)
      .reduce((acc, total) => {
        return toDinero(total).add(acc)
      }, toDinero("0"))
      .toFormat("$0,0.00")
    return (
      <li key={`category-${category.id}`} className="table-list-row category">
        <div className="category-name">
          <strong>{category.name}</strong>
          <span className="is-nfw">{categorySum}</span>
        </div>
        <ul className="category-items">{items.map(this.renderItem)}</ul>
      </li>
    )
  }

  renderRemarksToggle() {
    const {t} = this.props
    if (this.state.showRemarks == true) {
      return (
        <a
          href="#"
          className="ml-1 float-right small"
          onClick={this.handleToggleRemarks}
        >
          {t("intake.babyList.main.showRemarks.hide")}
        </a>
      )
    }
    return (
      <a
        href="#"
        className="ml-1 float-right small"
        onClick={this.handleToggleRemarks}
      >
        {t("intake.babyList.main.showRemarks.show")}
      </a>
    )
  }

  renderMainList() {
    const {t, babyList, allProducts, categories} = this.props
    const chunkedByCategory = getBabyListItemsByCategory(
      babyList,
      allProducts,
      categories
    )
    return (
      <div className="intake-baby-list-main-list">
        <div className="row mb-4">
          <div className="col-md-12">
            <h2 className="mb-0 d-inline">{t("intake.babyList.main.title")}</h2>
            {hasRemarks(babyList) ? this.renderRemarksToggle() : null}
          </div>
        </div>
        {this.renderHeaderTotal()}
        <div className="table-list">
          <div className="table-list-header">
            <div className="table-list-row row">
              <div className="col col-md-9">
                {t("intake.babyList.main.columns.item")}
              </div>
              <div className="col col-md-1 justify-content-center is-nfw">
                {t("intake.babyList.main.columns.amount")}
              </div>
              <div className="col col-md-1 justify-content-center is-nfw">
                {t("intake.babyList.main.columns.priceNew")}
              </div>
              <div className="col col-md-1 justify-content-end price-col is-nfw">
                {t("intake.babyList.main.columns.priceSelling")}
              </div>
            </div>
          </div>
          <ul className="table-list-body">
            {chunkedByCategory.map(this.renderCategory)}
          </ul>
        </div>
      </div>
    )
  }

  renderOptionals() {
    const {
      t,
      optionals,
      match: {
        params: {babyToken},
      },
    } = this.props
    if (optionals.length == 0) {
      return null
    }
    return (
      <div className="intake-baby-list-optionals mt-5">
        <h2>{t("intake.babyList.optionals.title")}</h2>
        <>
          {t("intake.babyList.optionals.descriptionPrefix")}
          <Link to={`/intake/${babyToken}/categories/optionals`}>
            {t("intake.babyList.optionals.link")}
          </Link>
          {t("intake.babyList.optionals.descriptionSuffix")}
        </>
      </div>
    )
  }

  renderLaters() {
    const {
      t,
      laters,
      match: {
        params: {babyToken},
      },
    } = this.props
    if (laters.length == 0) {
      return null
    }
    return (
      <div className="intake-baby-list-virtual">
        <h2>{t("intake.babyList.laters.title")}</h2>
        <React.Fragment>
          {t("intake.babyList.laters.descriptionPrefix")}
          <Link to={`/intake/${babyToken}/categories/laters`}>
            {t("intake.babyList.laters.link")}
          </Link>
          {t("intake.babyList.laters.descriptionSuffix")}
        </React.Fragment>
      </div>
    )
  }

  renderHeaderTotal() {
    const {t, babyList} = this.props
    const total = toDinero("" + babyList.total).toFormat("$0,0.00")
    const totalNew = getBabyListTotalNew(babyList).toFormat("$0,0.00")
    return (
      <div className="row intake-baby-list-totals is-compact">
        <div className="col-md-9" />
        <div className="col-md-1 text-center">
          <strong className="mr-2">{t("intake.babyList.totals.label")}</strong>
        </div>
        <div className="col-md-1 text-right">
          <strong className="is-nfw">{totalNew}</strong>
        </div>

        <div className="col-md-1 text-right">
          <strong className="is-nfw">{total}</strong>
        </div>
      </div>
    )
  }

  renderFooterTotal() {
    const {
      t,
      babyList,
      offers,
      match: {
        params: {babyToken},
      },
      offerSending,
    } = this.props
    const total = toDinero("" + babyList.total).toFormat("$0,0.00")
    const exportLink = babyList.items.length ? (
      <a
        className="btn btn-outline-secondary"
        href={Config.baseUrl + `/intake/${babyToken}/export/csv`}
      >
        {t("intake.babyList.totals.export")}
      </a>
    ) : null
    const latestVersion =
      offers && offers.length ? (
        <small className="d-block mt-2">
          {t("intake.babyList.totals.latestVersion.prefix")}{" "}
          <em>{offers[0].version}</em>{" "}
          {t("intake.babyList.totals.latestVersion.timePrefix")}{" "}
          <em>{offers[0].insertedAtLocalTime}</em>
        </small>
      ) : (
        <small className="d-block mt-2">
          {t("intake.babyList.totals.latestVersion.none")}
        </small>
      )
    return (
      <div className="intake-baby-list-totals">
        <div className="row text-right">
          <div className="col justify-content-end">
            <strong className="mr-3">
              {t("intake.babyList.totals.label")}
            </strong>
            <strong className="is-nfw">{total}</strong>
          </div>
        </div>
        <div className="mt-4 d-flex justify-content-between align-items-center">
          <div>
            {t("intake.babyList.totals.downloadTools")}
            <div className="btn-group btn-group-sm ml-2">
              {exportLink}
              <a
                className="btn btn-outline-secondary"
                rel="noopener noreferrer"
                target="_blank"
                href={Config.baseUrl + `/intake/${babyToken}/estimate.pdf`}
              >
                {t("intake.babyList.totals.viewPdf")}
              </a>
            </div>
          </div>
          <div className="text-right">
            <button
              disabled={offerSending}
              className="btn btn-primary"
              onClick={this.handleSendOffer}
            >
              {offerSending
                ? t("intake.babyList.totals.saveAndSendBusy")
                : t("intake.babyList.totals.saveAndSend")}
            </button>
            {latestVersion}
          </div>
        </div>
      </div>
    )
  }

  renderTasks() {
    const {
      generalTasks,
      clientTasks,
      madamTasks,
      t,
      match: {
        params: {babyToken},
      },
    } = this.props
    return (
      <div>
        <hr />
        {clientTasks.length > 0 ? (
          <React.Fragment>
            <div className="mb-4">
              <h5 className="mb-1">{t("intake.tasks.client.title")}</h5>
              <TaskList
                babyToken={babyToken}
                tasks={clientTasks}
                hideChecks={true}
              />
            </div>
            <hr />
          </React.Fragment>
        ) : null}
        <div>
          <h5
            className="mb-1"
            dangerouslySetInnerHTML={{
              __html: t("intake.tasks.general.title"),
            }}
          />
          {generalTasks.length > 0 ? (
            <TaskList
              babyToken={babyToken}
              tasks={generalTasks}
              hideChecks={true}
            />
          ) : (
            <em className="text-gray">
              <small>{t("intake.tasks.general.none")}</small>
            </em>
          )}
          <hr />
        </div>
        {madamTasks.length > 0 ? (
          <div>
            <a href="#" onClick={this.handleToggleMadamTasks} className="mb-1">
              {t("intake.tasks.madam.title")}
            </a>
            {this.state.showMadamTasks ? (
              <TaskList
                babyToken={babyToken}
                tasks={madamTasks}
                hideChecks={true}
              />
            ) : null}
            <hr />
          </div>
        ) : null}
      </div>
    )
  }

  renderMoodboardType() {
    const {baby, t} = this.props
    const moodboardType =
      baby.moodboardType == "" ? "unknown" : baby.moodboardType
    return (
      <div className="row">
        <div className="col">
          <strong className="mb-0">
            <a href={t("intake.babyList.main.moodboardInfoUrl")} target="blank">
              {t("intake.babyList.main.moodboardType")}:&nbsp;
            </a>
            <a href={`/admin/babies/${baby.id}`}>
              {t("intake.babyList.main.moodboardTypes." + moodboardType)}
            </a>
          </strong>
          <hr />
        </div>
      </div>
    )
  }

  renderShouldMailAll() {
    const {baby, t} = this.props
    return (
      <div className="row">
        <div className="col">
          <strong className="mb-0">
            {t("intake.babyList.main.shouldMailAll.title")}:&nbsp;
            <a href={`/admin/babies/${baby.id}`}>
              {baby.family.shouldMailAll
                ? t("intake.babyList.main.shouldMailAll.yes")
                : t("intake.babyList.main.shouldMailAll.no")}
            </a>
          </strong>
          <hr />
        </div>
      </div>
    )
  }

  render() {
    const {baby, babyList} = this.props
    return (
      <>
        <div className="intake-view-container">
          <div className="intake-view-main">
            <div className="row">
              <div className="col-lg-9">
                {this.renderMainList()}
                {this.renderFooterTotal()}
              </div>
              <div className="col-lg-3">
                {this.renderMoodboardType()}
                {this.renderShouldMailAll()}
                {this.renderLaters()}
                {this.renderOptionals()}
                {baby.states.includes("signed") &&
                hasInvoiceableWebshopSource(babyList, "intake_not_invoiced") &&
                hasInvoiceableWebshopSource(babyList, "bundling") ? (
                  <>
                    <hr />
                    <p>
                      We zien dat er nog te factureren webshop producten actief
                      staan op de intake, naast het gebundelde &quot;Producten
                      eigen webshop&quot;. Mogen deze gedeactiveerd worden voor
                      facturatie?
                    </p>
                    <button
                      className="btn btn-warning"
                      onClick={this.handleDisableWebshopSource}
                    >
                      Deactiveer
                    </button>
                  </>
                ) : null}
                <div className="row">
                  <div className="col">{this.renderTasks()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.renderDisableWebshopSourceModal()}
        {this.renderModal()}
      </>
    )
  }
}

const mapStateToProps = (state: ReduxState): any => ({
  categories: getProductCategories(state),
  productsByCategory: state.products.entities.products,
  allProducts: getAllProducts(state.products.entities.products),
  offerSending: state.baby.offerSending,
  baby: state.baby.baby,
  babyList: state.baby.list,
  optionals: state.baby.optionals,
  offers: state.baby.offers,
  laters: getProductsForLater(state.products.entities.products),
  clientTasks: getTasksByTypes(state, ["client"]),
  madamTasks: getTasksByTypes(state, ["madam"]),
  generalTasks: getTasksByTypes(state, ["general"]),
})

export default withTranslation()(connect(mapStateToProps)(IntakeBabyListView))
